import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { attendeesAPI } from '../services/api';

const PhotoMosaic = () => {
  const { projectId } = useParams();
  const [photos, setPhotos] = useState([]);
  const [fillMode, setFillMode] = useState(false);

  useEffect(() => {
    loadPhotos();
    const interval = setInterval(loadPhotos, 10000); // Actualizar cada 10 segundos
    return () => clearInterval(interval);
  }, [projectId]);

  const loadPhotos = async () => {
    try {
      const response = await attendeesAPI.getMosaicPhotos(projectId, { checkedInOnly: true });
      setPhotos(response.data.photos);
    } catch (error) {
      console.error('Error cargando fotos:', error);
    }
  };

  const getDisplayPhotos = () => {
    if (!fillMode || photos.length === 0) return photos;

    // Calcular cuántas fotos necesitamos para llenar la pantalla
    const targetCount = Math.ceil(window.innerWidth / 150) * Math.ceil(window.innerHeight / 150);

    if (photos.length >= targetCount) return photos;

    // Repetir fotos para llenar
    const repeated = [];
    while (repeated.length < targetCount) {
      repeated.push(...photos);
    }
    return repeated.slice(0, targetCount);
  };

  const displayPhotos = getDisplayPhotos();
  const apiUrl = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:3001';

  return (
    <div className="min-h-screen bg-black">
      <div className="fixed top-0 right-0 p-4 z-50">
        <button
          onClick={() => setFillMode(!fillMode)}
          className="bg-white bg-opacity-50 hover:bg-opacity-75 text-black px-4 py-2 rounded-lg transition"
        >
          {fillMode ? 'Modo Normal' : 'Rellenar Mosaico'}
        </button>
      </div>

      <div className="photo-mosaic p-4">
        {displayPhotos.map((photo, index) => (
          <div key={`${photo.id}-${index}`} className="photo-mosaic-item">
            <img
              src={`${apiUrl}${photo.photoUrl}`}
              alt={photo.fullName}
              onError={(e) => e.target.src = 'https://via.placeholder.com/150?text=No+Image'}
            />
            <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white p-2 text-xs">
              {photo.fullName}
            </div>
          </div>
        ))}
      </div>

      {photos.length === 0 && (
        <div className="flex items-center justify-center h-screen text-white text-2xl">
          Esperando asistentes...
        </div>
      )}
    </div>
  );
};

export default PhotoMosaic;
